/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable no-restricted-syntax */
import historyContext from '../contexts/history-context';

export interface URLparams {
  query?: string;
  filters?: string[];
  'dealer-id'?: string;
  'geolocation-lat'?: number;
  'geolocation-lng'?: number;
  'triggered-by-teaser'?: boolean | string;
  selected?: string;
  country?: string;
  favorite?: string;
}

export function useURLService() {
  const { historyService } = historyContext.useHistoryState();

  function generateUrl(appURL: string, params: URLparams, key?: string) {
    let p: keyof URLparams;
    for (p in params) {
      if (!params[p]?.toString().length) {
        // eslint-disable-next-line no-param-reassign
        delete params[p];
      }
    }
    const searchParams = new URLSearchParams(params as URLSearchParams);

    const historyServiceUrl = historyService?.createNewRootLocationForMultipleConsumers({
      historyKey: key || historyService.historyKey,
      location: { search: searchParams.toString() },
    });

    const url = new URL(`${historyServiceUrl?.search}${historyServiceUrl?.hash}` || '', appURL);
    return url;
  }

  return generateUrl;
}
